/**
 * `<main>`'İ TAMAMEN DOLDURAN EKRANLAR — kabuğun iki kararının TEK kaynağı (18 Eylül 2026).
 *
 * 1. `<main>` sohbet düğmesinin alt rezervini taşısın mı (`main-scroller.ts`). Bu ekranlar
 *    `<main>`'in yüksekliğinin tamamını `100%` ile alıyor ve kendi içlerinde kayıyor; `<main>`'in
 *    88 piksellik alt boşluğu burada hiçbir kontrolü korumuyor, yalnız altta sayfa zemini
 *    bırakıyordu (Notlarım). Rezerv, düğme çiziliyorsa, ekranın iç kaydırıcısında.
 * 2. Köşedeki sohbet düğmesi çizilsin mi (`chat-launcher-visibility.ts`). Belge düzenleyicide
 *    ekranın sağ alt köşesi gömülü Collabora çerçevesinin: düğme onun yakınlaştırma denetimlerinin
 *    üstüne biniyordu (Sohbet 21'in kuralı: yüzen düğme sayfanın denetimlerini örtmez). Orada
 *    düğme yok; sohbete üst çubuğun araması, ray ve telefonda ☰ çekmecesi götürüyor. Notlarım'da
 *    düğme kalıyor — o köşe uygulamanın kendi belgesi ve rezervini taşıyor.
 *
 * Bir ekranı buraya eklemek iki kararı birden veriyor; ikisi ayrı listelerde dursaydı biri
 * güncellenip öteki unutulurdu.
 */
interface FullScreenRoute {
  matches: (pathname: string) => boolean;
  /** Sağ alt köşe uygulamanın olmayan denetimlerle dolu (gömülü çerçeve): düğme çizilmez. */
  hidesChatLauncher: boolean;
}

const FULL_SCREEN_ROUTES: readonly FullScreenRoute[] = [
  /** Notlarım: `/notes` ve `/notes/:noteId` (`/notes/new` dahil). */
  {
    matches: (pathname) => pathname === "/notes" || pathname.startsWith("/notes/"),
    hidesChatLauncher: false,
  },
  /** Belge düzenleyici `/documents/:sessionId` — `/documents` (Dosyalarım) değil. */
  {
    matches: (pathname) => /^\/documents\/[^/]+\/?$/.test(pathname),
    hidesChatLauncher: true,
  },
];

export function fillsMainArea(pathname: string): boolean {
  return FULL_SCREEN_ROUTES.some((route) => route.matches(pathname));
}

export function hidesChatLauncher(pathname: string): boolean {
  return FULL_SCREEN_ROUTES.some((route) => route.hidesChatLauncher && route.matches(pathname));
}
